export const classes = {
  wrapper: 'place-center flex-col grow px-12',
  label: 'text-lg text-grey-7 dark:text-mauve-2 mb-2',
  progressBar: 'w-full mt-6',
};
